import { dataMovieSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMovieSolid = /*#__PURE__*/createIcon(dataMovieSolid)
export default IconMovieSolid
